import { ResultsWithMeta } from './types'

interface paginationInfoProps {
  data: ResultsWithMeta<any> | undefined
  config: { page: number; perPage: number }
  setConfig: (config) => any
  label: string
}

const calculateTotalResults = data => {
  return data?.meta?.count || 'Many'
}

const calculateTotalPages = data => {
  if (!data) return 0

  const { count, perPage } = data.meta

  if (!count) return 'Many'

  return Math.ceil(count / perPage)
}

const hasNextPage = (data, page, perPage, totalPages) => {
  if (!data) return false
  if (totalPages == 'Many') return data.results.length == perPage

  return page + 1 < (totalPages as number)
}

export const paginationInfo = ({
  data,
  config,
  setConfig,
  label,
}: paginationInfoProps) => {
  const { page, perPage } = config

  const nextPage = () =>
    setConfig(config => ({ ...config, page: config.page + 1 }))

  const prevPage = () =>
    setConfig(config => ({ ...config, page: config.page - 1 }))

  const setPerPage = (newValue: number) =>
    setConfig(config => ({ ...config, page: 0, perPage: newValue }))

  const totalPages = calculateTotalPages(data)
  const totalResults = calculateTotalResults(data)

  return {
    hasNextPage: hasNextPage(data, page, perPage, totalPages),
    hasPrevPage: !!data && page > 0,
    label,
    nextPage,
    page: page + 1,
    perPage,
    prevPage,
    setPerPage,
    totalPages,
    totalResults,
  }
}
